(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["floating-faq"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.querySelector('[data-faq-root]');
  if (!root) return;

  const trigger = root.querySelector('[data-faq-trigger]');
  if (!trigger) return;

  const target = document.querySelector('[id*="section_naGGTr"]');
  if (!target) {
    root.hidden = true;
    return;
  }

  root.hidden = false;

  const scrollToFaq = () => {
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const behavior = prefersReduced ? 'auto' : 'smooth';

    target.scrollIntoView({
      behavior,
      block: 'start',
      inline: 'nearest'
    });
  };

  trigger.addEventListener('click', scrollToFaq);
})();
  } catch(e) { console.error(e); }
})();

})();
